const flightsCatalog = new Set();

// Error management
flightsCatalog
    .add('flights-popup-session-expired')
    .add('flights-popup-broken-flow')
    .add('flights-popup-no-results')
    .add('errorCobaltUIDialog')
    .add('pax-continue-button')
    .add('showSearchExpiredErrorByTemplate')
    .add('sessionAboutToExpireAlert')
    .add('noFilteredResultsDialog')
    .add('sessionExpireDialog')
    // OF2 Elements display
    .add('of1-pax-page-continue-button')
    .add('of1-passenger-manager');

export default flightsCatalog;
